export default {
  InsufficientBalance: {
    en: 'Insufficient balance',
    ru: 'Недостаточно средств',
    ja: '残高不足'
  },
  TransactionFailed: {
    en: 'Transaction failed',
    ru: 'Ошибка транзакции',
    ja: '処理に失敗しました'
  },
  Days: {
    en: 'Days',
    ru: 'Дней',
    ja: '日々'
  },
  hours: {
    en: 'hours',
    ru: 'часов',
    ja: '時間'
  },
  Owned: {
    en: 'Owned',
    ru: 'Купленно',
    ja: '所有'
  },
  AllocationUpTo: {
    en: 'Tickets amount',
    ru: 'Билетов',
    ja: '',
  },
  Price: {
    en: 'Price',
    ru: 'Цена',
    ja: '価格'
  },
  Locked: {
    en: 'Locked',
    ru: 'Заблокировано',
    ja: 'ロック済み'
  },
  Claimable: {
    en: 'Claimable',
    ru: 'Доступно',
    ja: 'クレーム可能'
  },
  AlreadyClaimed: {
    en: 'Already claimed',
    ru: 'Уже получено',
    ja: 'すでに主張'
  },
  Claim: {
    en: 'Claim',
    ru: 'Получить',
    ja: '請求'
  },
  YourTickets: {
    en: 'Your tickets',
    ru: 'Ваши билеты',
    ja: 'あなたのチケット'
  },
  Buy: {
    en: 'Buy',
    ru: 'Купить',
    ja: '買う'
  },
  BuyMore: {
    en: 'Buy more',
    ru: 'Купить еще',
    ja: 'もっと買う'
  }
}